import { defineMessages } from 'react-intl';

export const assumptionEditationModalMessageDefinitions = defineMessages({
  title: {
    id: 'assumptionEditationModal.title',
    defaultMessage: 'Editation of Assumption',
  },
  assumptionType: {
    id: 'assumptionEditationModal.assumptionType',
    defaultMessage: 'Assumption Type',
  },
  assumptionTypePlaceholder: {
    id: 'assumptionEditationModal.assumptionCategoryDropdownPlaceholder',
    defaultMessage: 'Select Type',
  },
  description: {
    id: 'assumptionEditationModal.description',
    defaultMessage: 'Description',
  },
  descriptionPlaceholder: {
    id: 'assumptionEditationModal.descriptionPlaceholder',
    defaultMessage: 'Meaningful short description for management (max 210 characters)',
  },
});
